import styled from "styled-components";
import { Colors } from "../../commons/Colors";

export const Container = styled.main`
  text-align: center;
  line-height: 2;
  strong{
    margin-bottom: 24px;
    display: inline-block;
  }
  
  p{
    a{
      margin-right: 6px;
    }
  }



  @media screen and (min-width: 501px) {
  }

  @media (max-width: 500px) {
  }
`